var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"file","v-model":_vm.csvFile},on:{"change":_vm.handleCsvFile}})}
var staticRenderFns = []

export { render, staticRenderFns }